// External Packages
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';

// Internal Packages
import { getGoBaseUrl, isTrackingDisabled } from 'utils/url';
import { isInProduct } from 'utils/inProduct';
import getIsBabbelTrackingUuidSet from 'selectors/getIsBabbelTrackingUuidSet';

// Component Definition
class CampaignsTracker extends Component {
  constructor(props) {
    super(props);
    this.campaignsTracker = null;
  }

  componentDidMount() {
    this.trackPageView();
  }

  componentDidUpdate(previousProps) {
    if (
      this.props.shortlinkCode !== previousProps.shortlinkCode ||
      this.props.isTrackingUuidSet !== previousProps.isTrackingUuidSet
    ) {
      this.trackPageView();
    }
  }

  async trackPageView() {
    if (isTrackingDisabled || isInProduct(window.location.search)) {
      return;
    }

    if (!this.campaignsTracker) {
      const marketingTracker = await import('@lessonnine/marketing-tracker');
      this.campaignsTracker = new marketingTracker.CampaignsTracker({
        host: getGoBaseUrl(),
      });
    }
    if (this.props.isTrackingUuidSet) {
      this.campaignsTracker.trackPageview(this.props.shortlinkCode);
    }
  }

  render() {
    return null;
  }
}

const mapStateToProps = (state) => ({
  isTrackingUuidSet: getIsBabbelTrackingUuidSet(state),
});

const withRedux = connect(
  mapStateToProps,
  null,
);

// Component Metadata
CampaignsTracker.propTypes = {
  isTrackingUuidSet: PropTypes.bool.isRequired,
  shortlinkCode: PropTypes.string.isRequired,
};

export default withRedux(CampaignsTracker);
